import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { AES } from 'crypto-js';

import { getCustomerCardsService, productBookingCreate, markPrimaryCard, deleteCardService, productPaymmentBreakdown, } from '../../services/programService';

import { getitemsincart } from '../../store/cart';
import { billingDetailService } from '../../services/otherService';
import settings from '../../config/settings';
import { ProgramLoader } from '../reuse/SVG';
import { accountTypes, isNonEmptyArray, notificationMsg, resHandle } from '../../helper';
import { getCampDetailService } from '../../services/userServices';
import { getTaxForPrice, getWithTaxPrice } from '../bookings/bookingHelper';
import AddNewCard from './AddNewCard';
import SecureInput from './SecureInput';
import CreditCard from './CreditCard';
import CustomDropDown from '../reuse/UIComponents/CustomDropDown';
import ProductPriceDisplay from './ProductPriceDisplay';






const ProductPaymentGateway = props => {
    const [btnloder, setBtnloder] = useState(false);


    const [paymentMethod, setPaymentMethod] = useState(0);
    const [paymentMethodErr, setPaymentMethodErr] = useState('');
    const [isNewCard, setIsNewCard] = useState(false);
    const [cardList, setCardList] = useState([]);

    const [resErr, setResErr] = useState('');

    const [customerPaymentProfileId, setCustomerPaymentProfileId] = useState('');
    const [customerPaymentProfileIdErr, setCustomerPaymentProfileIdErr] = useState('');


    const [bankAccountType, setBankAccountType] = useState('');
    const [bankAccountNum, setBankAccountNum] = useState('');
    const [routingNumber, setRoutingNumber] = useState('');
    const [nameOnAccount, setNameOnAccount] = useState('');
    const [bankAccountTypeErr, setBankAccountTypeErr] = useState('');
    const [bankAccountNumErr, setBankAccountNumErr] = useState('');
    const [routingNumberErr, setRoutingNumberErr] = useState('');
    const [nameOnAccountErr, setNameOnAccountErr] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [billingDetail, setBillingDetail] = useState({});
    const [primaryCardId, setPrimaryCardId] = useState('');
    const [isDeletePopup, setIsDeletePopup] = useState(false);
    const [deleteCardToken, setDeleteCardToken] = useState('');
    const [isSwitchPrimaryCard, setIsSwitchPrimaryCard] = useState(false);
    const [holdPrimaryId, setHoldPrimaryId] = useState('');
    const [loader, setLoader] = useState(false);
    const [paymentLoader, setPaymentLoader] = useState(false);

    const [creditCardRate, setCreditCardRate] = useState({});
    const [achTransferRate, setAchTransferRate] = useState({});

    const [isFailed, setIsFailed] = useState(false);
    const [reload, setReload] = useState(false);
    const [showDeletedCards, setShowDeletedCards] = useState(false)
    const [campPaymentBreakDown, setCampPaymentBreakDown] = useState(null)




    useEffect(() => {

        if (props?.passData?.length) {
            let _totalAmount = 0;

            for (let i = 0; i < props?.passData.length; i++) {
                _totalAmount += props?.passData[i].price;
            }
            setTotalAmount(_totalAmount)
        }
    if (props.userProfile.campCode) {
            getTaxs();
        }
       
    }, [reload, props.products, props.userProfile.campCode, props.isNewCardAdd, props?.passData?.length, ])

    useEffect(() => {
        if (props?.products?.length || props?.passData?.length) {
            getCards();
        }

    }, [props.products, props?.passData, showDeletedCards])
    
    const getTaxs = async () => {
        try {
            setPaymentLoader(true);
            let query = `?campCode=${props.userProfile.campCode}`;
            const _campDetails = getCampDetailService(query);
            const _billingDetails = billingDetailService();
            const timeout = new Promise((_, reject) =>
                setTimeout(() => reject(new Error('timeout')), 15000)
            );
            const [res, res1] = await Promise.race([
                Promise.all([_campDetails, _billingDetails]),
                timeout
            ]);
            if (res?.data?.statusCode) {
                let _data = res.data.responseData.result;
                setCreditCardRate(_data.creditCardRate || {});
                setAchTransferRate(_data.achTransferRate || {});
            }
            if (res1?.data?.statusCode) {
                setBillingDetail(res1.data.responseData.billingDetail);
            }
        } catch (error) {
            setIsFailed(true);
        } finally {
            setPaymentLoader(false);
        }
    }

    useEffect(() => {
        if(paymentMethod){
            getProductPayBreakDown()
        }
    }, [paymentMethod])

    const getProductPayBreakDown = async () => {
         let cartIds =[]
        if(props?.products?.length){
             cartIds = JSON.stringify(props.products.map(({cartId}) => cartId))
        }
        const params = {
            isWeb: 1,
            cartIds,
            paymentType:paymentMethod
        }
       const res = await  productPaymmentBreakdown(params);
       const {status, data } = resHandle(res)
        if(status){
            setCampPaymentBreakDown(data)
            setTotalAmount(data.payableAmount)
        }
    
    }


    const getCards = async () => {
        setCardList([]);
        setHoldPrimaryId('');
        setPrimaryCardId('');
        try {
            setLoader(true);
            let query = ``;
            if (props?.passData?.length) {
                query = `?isWeb=1&userId=${props.userId}&campCode=${props.userProfile.campCode}&includeDeleted=${showDeletedCards}`;
            } else {
                query = `?isWeb=1&campCode=${props?.products[0]?.campCode}&includeDeleted=${showDeletedCards}`;
            }
            const res = await getCustomerCardsService(query)
            if (res.data.statusCode) {
                if (res.data.responseData.result?.length) {
                    const cardList = res.data.responseData.result
                    setCardList(cardList);
                    let primaryCard = ''
                    for (let i = 0; i < cardList.length; i++) {
                        if (cardList[i]?.card?.metadata?.primary) {
                            primaryCard = cardList[i].card.token;
                        } else {
                            continue;
                        }
                    }
                      if(cardList.length){
                        const _selectedCard = cardList[0]?.card?.token ?? "";
                        setCustomerPaymentProfileId(_selectedCard)
                    }
                    setPrimaryCardId(primaryCard)
                } else {
                    setIsNewCard(true);
                }
            } else {
                setCardList([]);
            }
            // setLoader(false)
        } catch (error) {
            //TODO: Show error
            setIsFailed(true)
        } finally {
            setLoader(false)
        }
    }


    const handleValidate = () => {
        let validate = true;

        if (paymentMethod === 0) {
            validate = false;
            setPaymentMethodErr('Please select payment method');
        }

        if (paymentMethod === 1) {
            if (customerPaymentProfileId === '') {
                validate = false;
                setCustomerPaymentProfileIdErr('Please select a card')
            }
        }

        if (paymentMethod === 4) {

            if (bankAccountType === '' || bankAccountType === 'undefined' || bankAccountType === null) {
                validate = false;
                setBankAccountTypeErr('Account type is required')
            }

            if (bankAccountNum === '' || bankAccountNum === 'undefined' || bankAccountNum === null) {
                validate = false;
                setBankAccountNumErr('Account number is required')
            }

            if (routingNumber === '' || routingNumber === 'undefined' || routingNumber === null) {
                validate = false;
                setRoutingNumberErr('Routing number is required')
            }

            if (nameOnAccount === '' || nameOnAccount === 'undefined' || nameOnAccount === null) {
                validate = false;
                setNameOnAccountErr('Account holder name is required')
            }

        }


        return validate;
    }





    const submitRegistration = () => {
        setResErr('');
        if (handleValidate()) {
            setBtnloder(true);
            let payment = {};

            let params = {
                isWeb: 1,
                price: totalAmount,
                userId: props.userId,
                
            };
            
            if (props?.passData?.length) {
                let _itemIds = props?.passData.map(j => j.itemId);
                let _cartIds = props?.passData.map(j => j.cartId);
                params.itemIds = JSON.stringify(_itemIds);
                params.cartIds = JSON.stringify(_cartIds);
                params.billingDetail = JSON.stringify(billingDetail)
            } else {
                params.itemIds = JSON.stringify(props.products.map(i => i.itemId))
                params.cartIds = JSON.stringify(props.products.map(i => i.cartId))
            }




            if (paymentMethod === 1) {
                params.payment = JSON.stringify({
                    method: 'Credit Card',
                    amount: getWithTaxPrice(creditCardRate, totalAmount),
                    applicationFeeAmount: getTaxForPrice(creditCardRate, totalAmount)
                });
                params.authPayment = JSON.stringify({
                    paymentType: 1,
                    token: customerPaymentProfileId
                });
            }


            if (paymentMethod === 6) {
                params.payment = JSON.stringify({
                    method: 'Pay Later',
                    amount: 0,
                    status: 2
                });

                params.partialPayment = true;
                params.remainingAmount = totalAmount;
                params.totalAmount = totalAmount;

            }



            if (paymentMethod === 4) {
                params.payment = JSON.stringify({
                    method: 'Internet Banking',
                    amount: getWithTaxPrice(achTransferRate, totalAmount),
                    applicationFeeAmount: getTaxForPrice(achTransferRate, totalAmount)
                });


                const __routing_number = AES.encrypt(routingNumber, settings.api.mySecretKey).toString();
                const __bankAccountNum = AES.encrypt(bankAccountNum, settings.api.mySecretKey).toString();


                params.internetBanking = 1;
                params.authPayment = JSON.stringify({
                    account_owner_name: nameOnAccount,
                    routing_number: __routing_number,
                    account_number: __bankAccountNum,
                    account_type: bankAccountType.value,
                    account_owner_type: 'individual',
                    country: 'US',
                    currency: 'usd',
                    paymentType: 4
                });
            }



            productBookingCreate(params).then(res => {
                if (res.data.statusCode === 1) {
                    props.callback()
                } else {
                    setResErr(res.data.error?.responseMessage || 'Something went wrong. Please try again.')
                }
            }).catch(() => {
                setResErr('Something went wrong. Please try again.')
            }).finally(() => {
                setBtnloder(false);
            })

        } else {
            setBtnloder(false);

        }
    }


    const handleDeleteCard = (cardId) => {
        setIsDeletePopup(true);
        setDeleteCardToken(cardId)
    }
    const deleteCardAction = () => {
        const params = {
            userId: props?.passData?.length ? props.userId : props.userProfile._id,
            cardToken: deleteCardToken,
        }
        //added api call to remove the card using card id. 
        deleteCardService(params).then(res => {
            if (res.status) {
                getCards()
                setCardList(cardList.filter(card => card.card.id !== deleteCardToken));
                setIsDeletePopup(false)
            }
        }).catch(error => {
            console.log(error)
        })
            .finally(() => {
                setIsDeletePopup(false)
            }
            )

    }
    const handlePrimaryCardAction = async () => {

        const params = {
            cardToken: holdPrimaryId,
            userId: props?.passData?.length ? props.userId : props.userProfile._id,
        }
        const res = await markPrimaryCard(params)
        if (res.status) {
            setIsSwitchPrimaryCard(false)
            getCards();
            setPrimaryCardId(holdPrimaryId);
        }
    }
    const handlePrimaryCard = (id) => {
        setHoldPrimaryId(id)
        setIsSwitchPrimaryCard(true)
    }

    const handleBankAccountNumberChange = (e) => {
        setBankAccountNum(e.target.value);
        setBankAccountNumErr('');
    }
    return (
        isFailed ? 
        <div className=" ps-4 pe-4 d-flex flex-column justify-content-center align-items-center">
            <h3>Product Payment Gateway</h3>
            <p className='text-danger mt-1'>Sorry, something went wrong.</p>
            <p className='text-danger mb-1'>Please try again.</p>
            <button className='btn btn-sm btn-secondary m-3' onClick={()=> {setIsFailed(false); setReload(prev => !prev)}}>Retry</button>
        </div>
        :
        <div className="payment-gateway ps-4 pe-4">
            <Modal
                show={isDeletePopup || isSwitchPrimaryCard}
                animation={false}
                dialogClassName="folder_model"
                size="lg"
                centered
            >
                {isSwitchPrimaryCard &&
                    <Modal.Body>
                        <span className="modal_close" onClick={() => { setIsSwitchPrimaryCard(false) }}><i className="icon-cross" /></span>
                        <div className="text-center p-5 pickup_modal_body">
                            <p>Are you sure you want to change your primary card ?</p>
                        </div>
                        <div className="text-center p-5">
                            <button onClick={() => { setPrimaryCardId(''); setIsSwitchPrimaryCard(false) }} style={{ width: '120px' }} className="btn btn-light rounded-0">No</button>
                            <button onClick={handlePrimaryCardAction} style={{ width: '120px' }} className="btn btn-primary ms-3">Yes</button>
                        </div>
                    </Modal.Body>

                }
                {isDeletePopup &&
                    <Modal.Body>
                        <span className="modal_close" onClick={() => { setIsDeletePopup(false) }}><i className="icon-cross" /></span>
                        <div className="text-center p-5 pickup_modal_body">
                            <p>Are you sure you want to remove this card ?</p>
                        </div>
                        <div className="text-center p-5">
                            <button onClick={() => { setDeleteCardToken(''); setIsDeletePopup(false) }} style={{ width: '120px' }} className="btn btn-light rounded-0">No</button>
                            <button onClick={deleteCardAction} style={{ width: '120px' }} className="btn btn-primary ms-3">Yes</button>
                        </div>
                    </Modal.Body>

                }
            </Modal>


            <Fragment>
                <h3>Select a Payment Option</h3>

                {paymentLoader ? <div className="program_loader"><ProgramLoader /></div> :
                    <div className="row">

                        <div className="col-md-6">
                            <div
                                className={`payment-gateway-card ${paymentMethod === 1 ? 'active' : ''}`}
                                onClick={() => (setPaymentMethod(1), setPaymentMethodErr(''))}>
                                <h4>Credit Card / Debit Card</h4>
                                {(props.userProfile.UserType !== 1 && totalAmount > 0) &&
                                    <>
                                        <h2>${getWithTaxPrice(creditCardRate, totalAmount)}</h2>
                                        <p>Payment Includes {creditCardRate.percentage}% + {`$${creditCardRate.taxRate}`} Processing Charge</p>
                                    </>
                                }
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div
                                className={`payment-gateway-card ${paymentMethod === 4 ? 'active' : ''}`}
                                onClick={() => (setPaymentMethod(4), setPaymentMethodErr(''))}>
                                <h4>Internet Banking</h4>
                                {(props.userProfile.UserType !== 1 && totalAmount > 0) &&
                                    <>
                                        <h2>${getWithTaxPrice(achTransferRate, totalAmount)}</h2>
                                        <p>Payment Includes {achTransferRate.percentage}% + {`$${achTransferRate.taxRate}`} Processing Charge</p>
                                    </>
                                }
                            </div>
                        </div>


                        {
                            props.userProfile.UserType !== 1 ? totalAmount ? <div className="col-md-6">
                                <div className={`payment-gateway-card ${paymentMethod === 6 ? 'active' : ''}`}
                                    onClick={() => (setPaymentMethod(6), setPaymentMethodErr(''))}>
                                    <h4>Pay Later</h4>
                                    {totalAmount > 0 &&
                                        <>
                                            <h2>${getWithTaxPrice(creditCardRate, totalAmount)}</h2>
                                            <p>Payment Includes {creditCardRate.percentage}% + {`$${creditCardRate.taxRate}`} Processing Charge</p>
                                        </>
                                    }
                                </div>
                            </div> : '' : ''
                        }

                    </div>
                }
                {props.userProfile.UserType === 1 && campPaymentBreakDown !== null &&
                    <ProductPriceDisplay data={campPaymentBreakDown} />
                }

                {paymentMethodErr ? <p className="color_red">{paymentMethodErr}</p> : ''}
                {
                    paymentMethod === 1 ? (
                        <Fragment>
                              {props.userProfile.UserType === 2  && <div className='mb-2'>

                                        <div className="check_box_wrapper cm_dark_check pt-1 ">
                                            <label>Show deleted cards</label>
                                            <input
                                                checked={showDeletedCards}
                                                onChange={() => setShowDeletedCards(!showDeletedCards)}
                                                type="checkbox"
                                                name="gender"
                                                value="male" />
                                            <span className="check_box"><span></span></span>
                                        </div>

                                    </div>}


                            <ul className="card_list">
                                {loader ?
                                    <div className="program_loader"><ProgramLoader /></div>
                                    :
                                    cardList.length ? cardList.map(item => (
                                        <li key={item.signature} className={customerPaymentProfileId === item.card.token ? 'active' : ''} style={{ justifyContent: 'space-between' }}>
                                            <CreditCard
                                                item={item}
                                                customerPaymentProfileId={customerPaymentProfileId}
                                                setCustomerPaymentProfileId={setCustomerPaymentProfileId}
                                                setCustomerPaymentProfileIdErr={setCustomerPaymentProfileIdErr}
                                                handlePrimaryCard={handlePrimaryCard}
                                                handleDeleteCard={handleDeleteCard}
                                            />

                                        </li>

                                    )) : ''
                                }
                            </ul>

                            {customerPaymentProfileIdErr ? <p className="color_red text-center">{customerPaymentProfileIdErr}</p> : ''}



                            { //TODO: Re-factor this component more.
                                isNewCard ? (
                                    <AddNewCard
                                        setIsNewCard={setIsNewCard}
                                        email={props.userEmail || props.userProfile.email}
                                        userId={props.userId}
                                        getCards={getCards}
                                        setResErr={setResErr}
                                        campCode={(props?.passData?.length) ?
                                            props?.userProfile?.campCode : props.products.map(i => i.campCode)
                                        }
                                    />

                                ) : <button className="btn btn-primary mb-3" onClick={() => setIsNewCard(true)}>Add New Card</button>
                            }
                        </Fragment>
                    ) : ''
                }





                {
                    paymentMethod === 4 ? (
                        <Fragment>
                            <div className="card_inputs add_card_form">
                                <CustomDropDown
                                    className="form-group"
                                    label={'Select Account Type'}
                                    error={bankAccountTypeErr}
                                    onChange={e => { setBankAccountType(e); setBankAccountTypeErr('') }}
                                    options={accountTypes}
                                />

                                <div className="form-group">
                                    <label>Routing Number</label>
                                    <input
                                        type='number'
                                        className={`form-control ${routingNumberErr ? 'is-invalid' : ''}`}
                                        value={routingNumber}
                                        placeholder="Routing Number"
                                        name="routingNumber"
                                        onChange={e => (setRoutingNumber(e.target.value), setRoutingNumberErr(''))} />

                                    {routingNumberErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{routingNumberErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}

                                </div>

                                <div className="form-group">
                                    <label>Account Number</label>
                                    <SecureInput
                                        type='number'
                                        error={bankAccountNumErr}
                                        value={bankAccountNum}
                                        name={"bankAccountNum"}
                                        placeholder={"Account Number"}
                                        maxLength={30}
                                        onChange={handleBankAccountNumberChange}
                                    />

                                    {bankAccountNumErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{bankAccountNumErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}

                                </div>





                                <div className="form-group">
                                    <label>Account Holder Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${nameOnAccountErr ? 'is-invalid' : ''}`}
                                        name="nameOnAccount"
                                        value={nameOnAccount}
                                        onChange={e => (setNameOnAccount(e.target.value), setNameOnAccountErr(''))}
                                        placeholder="Account Holder Name" />

                                    {nameOnAccountErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{nameOnAccountErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                </div>




                            </div>



                        </Fragment>
                    ) : ''
                }
            </Fragment>


            {resErr ? <p className="error_msg">{resErr}</p> : ''}



            {!(paymentMethod === 0) &&
                <div className="text-center mb-4 mt-4">
                    <span onClick={() => btnloder ? null : submitRegistration()} className={`btn btn-primary  ${btnloder ? 'btnLoader' : ''}`} >Buy now</span>
                </div>
            }

        </div>
    )
}


const mapStateToProps = state => {
    let { loggedIn, userProfile } = state.user;
    let { isNewCardAdd } = state.ui;
    let itemsincart = state.cartReducer.cartitems;
    return {
        loggedIn,
        isNewCardAdd,
        itemsincart,
        userProfile
    }
}

const mapDispatchToProps = dispatch => ({
    getitemsincart: params => dispatch(getitemsincart(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductPaymentGateway);

